import 'slick-carousel'

export default () => {

  let sliderHeader = $('.hero-slider');

  if (sliderHeader.length >= 1) {
    sliderHeader.slick({
      infinite: true,
      arrows: false,
      fade: true,
      speed: 2000,
      rows: 0,
      cssEase: "linear",
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4800,
    });
  }

  setTimeout(function () {
    $('.hero-slider__slide-content img').addClass("animate__fadeInRight");
    $('.hero-slider__slide-content p').addClass("animate__fadeInUp");
    $('.hero-slider__slide-content a').addClass("animate__fadeInDown animElem btn-light");
  }, 1000);

}


// WEBPACK FOOTER //
// ./scripts/modules/slider-settings.js